import React from "react";

import { Text, Icon } from "@soluto-design/react";
import Link, { LinkProps } from "@soluto-design/link";
export interface RatingProps {
  value: number;
  max?: number;
  link?: LinkProps;
  className?: string;
}

import cls from "@soluto-design/styles/cls";

const Rating: React.FC<RatingProps> = ({ max = 5, value, link, className }) => {
  const filledStars = Math.floor(value);
  const hasHalfStar = value % 1 !== 0;

  const valueRounded = value.toFixed(1);

  const stars = Array.from({ length: max }, (_, index) => {
    let kindStart = hasHalfStar && index === filledStars ? "half" : "star";

    let isFilled =
      index < filledStars || (hasHalfStar && index === filledStars);

    return (
      <Icon
        key={`start-${index}`}
        icon={
          kindStart === "half"
            ? "star--type-half"
            : isFilled
            ? "star--type-filled"
            : "star--type-empty"
        }
        className="text-brand-quaternary-700 text-[20px]"
      />
    );
  });

  const ratingContent = (
    <>
      <div className="flex gap-4">{stars}</div>
      <div className="flex gap-8 pt-4">
        <Text component="span">{valueRounded}</Text>
        {!!link?.children && (
          <Text component="span" className="underline">
            {link.children}
          </Text>
        )}
      </div>
    </>
  );

  return link ? (
    <Link
      {...link}
      className={cls(
        "flex !no-underline items-center gap-12 text-c100 !font-regular",
        className
      )}
    >
      {ratingContent}
    </Link>
  ) : (
    <div
      className={cls(
        "flex items-center gap-12 text-c100 !font-regular",
        className
      )}
    >
      {ratingContent}
    </div>
  );
};

export default Rating;
